import { useRef } from "react";

import styled from "styled-components";

import {
  FloatingButton,
  InnerWrapper,
  iconPaddingRight,
} from "NavBar/components/FloatingButtonPanel/ButtonStyles";
import IconWrapper from "NavBar/components/FloatingButtonPanel/IconWrapper";
import useIsSelected from "NavBar/components/useIsSelected";
import { navSectionKeys } from "NavBar/navBarStore";
import { useCloseNavIfOpen } from "NavBar/stateHooks";

import FnrContainedIcon from "UI/FnrContainedIcon";
import FnrSimpleReveal from "UI/FnrSimpleReveal";
import FnrTypography from "UI/FnrTypography";
import { navAccentColors } from "UI/colors";

import {
  useIsFocusVisible,
  useIsHovered,
} from "Utilities/Hooks/useIsHoverFocused";
import { addLeadingSlash } from "Utilities/stringTransformers";

import { importSignupsAll } from "../prefetch";

import { useShowButtonText } from "./floatingSearchStore";
import {
  activeBackgroundColor,
  inactiveBackgroundColor,
} from "./styleConstants";

const AllButton = () => {
  const buttonRef = useRef();
  const normalizedTo = addLeadingSlash("signups/all");
  const isSelected = useIsSelected(normalizedTo);
  const isHovered = Boolean(useIsHovered(buttonRef));
  const isFocusVisible = Boolean(useIsFocusVisible(buttonRef));
  const showButtonText = useShowButtonText();
  const closeNavIfOpen = useCloseNavIfOpen();

  const handleClick = () => {
    window.fnReactBus.goToUrl(normalizedTo);
    closeNavIfOpen();
  };

  return (
    <FloatingButton
      ref={buttonRef}
      onClick={handleClick}
      onMouseEnter={importSignupsAll}
      data-cy="NavBar_FloatingAllSignupsButton"
      aria-current={isSelected ? "page" : undefined}
      $glowColor={navAccentColors[navSectionKeys.signups][0]}
      $noGlow={!isSelected}
      $backgroundColor={
        isSelected ? activeBackgroundColor : inactiveBackgroundColor
      }
    >
      <InnerWrapper>
        <IconWrapper
          $paddingRight={showButtonText ? iconPaddingRight : 0}
          $isSearchActive={!showButtonText}
        >
          <FnrContainedIcon
            icon="clipboard-check fa-swap-opacity fad"
            size="sm"
            color="textLight"
            backgroundColor="transparent"
            noPadding
            noAnimation
            shadow
          />
        </IconWrapper>
        <FnrSimpleReveal show={showButtonText}>
          <TextWrapper>
            <FnrTypography
              fontSize="13px"
              lineHeight={1}
              color="textLight"
              shadow
              noWrap
            >
              ALL
            </FnrTypography>
          </TextWrapper>
        </FnrSimpleReveal>
        <FnrSimpleReveal show={showButtonText && (isHovered || isFocusVisible)}>
          <FnrTypography
            fontSize="13px"
            lineHeight={1}
            color="textLight"
            shadow
            noWrap
          >
            SIGNUPS
          </FnrTypography>
        </FnrSimpleReveal>
      </InnerWrapper>
    </FloatingButton>
  );
};

const TextWrapper = styled.div`
  padding-right: 4px;
`;

export default AllButton;
